import { useEffect, useState } from "react";
import { BannerHero } from "../../components/public/BannerHero";
import { CalculatorWidget } from "../../components/public/CalculatorWidget";
import { PublicLayout } from "../../components/PublicLayout";
import { api } from "../../lib/api";
import { bannerConfigs } from "../../lib/bannerConfig";

interface CalculatorSummary {
  member: null | {
    status: string;
    graduation_at?: string | null;
  };
  newbie_progress?: null | {
    step7_status?: string | null;
  };
}

export function CalculatorPage() {
  const account = localStorage.getItem("current_member_account") ?? localStorage.getItem("memberAccount") ?? "";
  const [summary, setSummary] = useState<CalculatorSummary | null>(null);

  useEffect(() => {
    if (!account) return;
    api<CalculatorSummary>(`/api/member/summary?member_account=${encodeURIComponent(account)}`)
      .then(setSummary)
      .catch(() => setSummary(null));
  }, [account]);

  const isGraduated = Boolean(summary?.member?.status === "graduated" || summary?.newbie_progress?.step7_status === "completed");
  const mode = isGraduated ? "regularRebate" : "newbie";

  return (
    <PublicLayout title={isGraduated ? "常態回饋試算器" : "新人禮試算器"} subtitle={isGraduated ? "正式成員單筆充值回饋試算" : "入盟啟動金額試算"}>
      <BannerHero banner={bannerConfigs.calculator} className="compact-page-banner" />
      <CalculatorWidget title={isGraduated ? "試算正式成員常態回饋" : "試算我的新人禮"} mode={mode} />
    </PublicLayout>
  );
}
